(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-look-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var state = {};
      var panels = root.querySelectorAll('[data-panel]');

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function parsePrice(str) {
        var m = String(str).replace(/[^0-9.]/g, '');
        return Math.round(parseFloat(m) * 100) || 0;
      }

      function updateTotal() {
        var total = 0;
        var allSelected = true;
        panels.forEach(function (panel) {
          var role = panel.dataset.role;
          if (state[role]) {
            total += parsePrice(state[role].price);
          } else {
            allSelected = false;
          }
        });
        var totalEl = root.querySelector('[data-sl-total]');
        if (totalEl) totalEl.textContent = money(total);
        var btn = root.querySelector('[data-sl-add-btn]');
        if (btn) btn.disabled = !allSelected;
      }

      panels.forEach(function (panel) {
        var role = panel.dataset.role;
        var toggle = panel.querySelector('.sl-toggle');
        var swatchWrap = panel.querySelector('.sl-swatches');
        var chosenLabel = panel.querySelector('[data-chosen-name]');
        var firstSw = panel.querySelector('.sl-sw');

        if (firstSw) {
          state[role] = {
            variantId: firstSw.dataset.variantId,
            price: firstSw.dataset.price,
            name: firstSw.dataset.name
          };
          if (chosenLabel) chosenLabel.textContent = firstSw.dataset.name;
        }

        if (toggle) {
          toggle.addEventListener('click', function () {
            var expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            if (swatchWrap) swatchWrap.hidden = expanded;
          });
        }

        panel.querySelectorAll('.sl-sw').forEach(function (sw) {
          sw.addEventListener('click', function () {
            panel.querySelectorAll('.sl-sw').forEach(function (s) {
              s.classList.remove('selected');
            });
            sw.classList.add('selected');
            state[role] = {
              variantId: sw.dataset.variantId,
              price: sw.dataset.price,
              name: sw.dataset.name
            };
            if (chosenLabel) chosenLabel.textContent = sw.dataset.name;
            updateTotal();
          });
        });
      });

      updateTotal();

      var addBtn = root.querySelector('[data-sl-add-btn]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [];
          panels.forEach(function (panel) {
            var role = panel.dataset.role;
            if (state[role]) {
              items.push({ id: state[role].variantId, quantity: 1 });
            }
          });
          if (!items.length) return;
          addBtn.disabled = true;
          var originalText = addBtn.textContent;
          addBtn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () {
              window.location.href = '/cart';
            })
            .catch(function () {
              addBtn.disabled = false;
              addBtn.textContent = originalText;
            });
        });
      }
    }

    document.querySelectorAll('.signature-look').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
